import styled, { keyframes, css } from "styled-components";
import { Box, lighten } from "@mui/material";
import { TemplateColorObject } from "../../../../InvitationColorMatrix";

const BURGUNDY = "#6b2737";
const DARK_BURGUNDY = "#4a1525";
const GOLD = "#c9a84c";
const LIGHT_GOLD = "#e8d5a3";
const CREAM = "#fdf8f0";
const TEXT_DARK = "#2c1810";

const fadeIn = keyframes`from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); }`;
const shimmer = keyframes`0%,100% { opacity: 0.7; } 50% { opacity: 1; }`;
const pulse = keyframes`0%,100% { transform: scale(1); } 50% { transform: scale(1.03); }`;

export const Wrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	width: 430px;
	max-width: 100%;
	margin: 0 auto;
	background: ${CREAM};
	font-family: "Georgia", serif;
	overflow: hidden;
	position: relative;
`;

export const FloralTop = styled.div`
	font-size: 48px;
	color: ${GOLD};
	text-align: center;
	transform: rotate(180deg);
	line-height: 1;
	margin-bottom: 12px;
	animation: ${shimmer} 3s ease-in-out infinite;
`;

export const FloralBottom = styled.div`
	font-size: 48px;
	color: ${GOLD};
	text-align: center;
	line-height: 1;
	margin-top: 12px;
	animation: ${shimmer} 3s ease-in-out infinite;
`;

export const GoldLine = styled.div`
	width: 80%;
	height: 2px;
	background: linear-gradient(90deg, transparent, ${GOLD}, transparent);
	margin: 12px auto;
`;

export const Divider = styled.div`
	width: 60%;
	height: 1px;
	background: linear-gradient(90deg, transparent, ${GOLD}, transparent);
	margin: 16px auto;
`;

export const HeroSection = styled.section<{ colormatrix: TemplateColorObject }>`
	background: ${props => props.colormatrix.overlay};
	padding: 32px 24px 40px;
	text-align: center;
	position: relative;
	animation: ${fadeIn} 0.8s ease-out;
	display: flex;
	flex-direction: column;
	align-items: center;
	&::before {
		content: "";
		position: absolute;
		inset: 0;
		background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 5 C20 15,5 20,5 30 C5 40,20 45,30 55 C40 45,55 40,55 30 C55 20,40 15,30 5Z' fill='%23c9a84c' opacity='0.05'/%3E%3C/svg%3E")
			repeat;
		pointer-events: none;
	}
	.wedding_of {
		color: ${LIGHT_GOLD};
		font-size: 14px;
		letter-spacing: 2px;
		margin: 8px 0;
		text-transform: uppercase;
	}

	button {
		background: ${props => props.colormatrix.button.background};
		color: ${props => props.colormatrix.button.text};
		border: none;
		padding: 12px 32px;
		font-size: 14px;
		letter-spacing: 2px;
		text-transform: uppercase;
		font-weight: 700;
		border-radius: 30px;
		cursor: pointer;
		margin-top: 16px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
		transition: transform 0.2s;
		&:hover {
			transform: scale(1.05);
		}
	}
`;

export const HeroImage = styled.div`
	img {
		width: 100%;
		max-height: 450px;
		background: #fff;
		border-radius: 12px;
		border: 3px solid ${GOLD};
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
		position: relative;
		&::after {
			content: "♥";
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 60px;
			color: rgba(201, 168, 76, 0.3);
		}
	}
`;

export const GroomName = styled.h1`
	font-size: 36px;
	color: ${LIGHT_GOLD};
	letter-spacing: 3px;
	margin: 10px 0;
	font-weight: 400;
	text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
`;

export const AndSymbol = styled.div`
	font-size: 52px;
	color: ${GOLD};
	line-height: 1;
	margin: 4px 0;
	font-family: "Times New Roman", serif;
	text-shadow: 0 0 20px rgba(201, 168, 76, 0.5);
	animation: ${pulse} 3s ease-in-out infinite;
`;

export const BrideName = styled.h1`
	font-size: 36px;
	color: ${LIGHT_GOLD};
	letter-spacing: 3px;
	margin: 10px 0;
	font-weight: 400;
	text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
`;

export const HeroDate = styled.p`
	color: ${LIGHT_GOLD};
	font-size: 18px;
	letter-spacing: 2px;
	margin: 8px 0;
	text-transform: uppercase;
`;

export const IntroMessage = styled.p`
	color: rgba(232, 213, 163, 0.85);
	font-size: 15px;
	font-style: italic;
	margin: 8px 16px;
`;

export const SaveDateBtn = styled.button`
	background: linear-gradient(135deg, ${GOLD}, #a07830, ${GOLD});
	color: ${DARK_BURGUNDY};
	border: none;
	padding: 12px 32px;
	font-size: 14px;
	letter-spacing: 2px;
	text-transform: uppercase;
	font-weight: 700;
	border-radius: 30px;
	cursor: pointer;
	margin-top: 16px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
	transition: transform 0.2s;
	&:hover {
		transform: scale(1.05);
	}
`;

export const CountdownSection = styled.section<{ colormatrix: TemplateColorObject }>`
	background: ${props => props.colormatrix.background};
	padding: 40px 24px;
	text-align: center;
	border-top: 3px solid ${GOLD};
	border-bottom: 3px solid ${GOLD};
	animation: ${fadeIn} 0.8s ease-out 0.2s both;

	.count_down_wrapper {
		margin-top: 30px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		.date {
			font-family: var(--roboto), sans-serif;
			font-size: 16px;
			letter-spacing: 1px;
			font-weight: 600;
			color: ${lighten("#000", 0.2)};
		}
		.counter_boxes_wrapper {
			display: flex;
			justify-content: center;
			gap: 12px;
			flex-wrap: wrap;
			.counter_box_wrapper {
				.counter_box {
					background: rgba(201, 168, 76, 0.1);
					border: 2px solid ${GOLD};
					border-radius: 8px;
					padding: 16px 10px;
					min-width: 45px;
					flex: 1;
					max-width: 80px;
					font-size: 32px;
					color: ${GOLD};
					font-weight: 700;
					line-height: 1;
				}
				p {
					font-size: 10px;
					color: ${LIGHT_GOLD};
					letter-spacing: 1px;
					text-transform: uppercase;
					margin-top: 4px;
				}
			}
		}
	}
`;

export const CountdownTitle = styled.h2`
	color: ${LIGHT_GOLD};
	font-size: 22px;
	letter-spacing: 2px;
	font-weight: 400;
	margin: 0 0 8px;
`;

export const CountdownGrid = styled.div`
	display: flex;
	justify-content: center;
	gap: 12px;
	flex-wrap: wrap;
`;

export const CountdownBox = styled.div`
	background: rgba(201, 168, 76, 0.1);
	border: 2px solid ${GOLD};
	border-radius: 8px;
	padding: 16px 12px;
	min-width: 72px;
	flex: 1;
	max-width: 80px;
`;

export const CountdownNum = styled.div`
	font-size: 32px;
	color: ${GOLD};
	font-weight: 700;
	line-height: 1;
`;

export const CountdownLabel = styled.div`
	font-size: 10px;
	color: ${LIGHT_GOLD};
	letter-spacing: 1px;
	text-transform: uppercase;
	margin-top: 4px;
`;

export const IntroSection = styled.section`
	background: ${CREAM};
	padding: 40px 28px;
	text-align: center;
	animation: ${fadeIn} 0.8s ease-out 0.3s both;
`;

export const QuranText = styled.p`
	font-size: 18px;
	color: ${BURGUNDY};
	direction: rtl;
	line-height: 1.8;
	margin: 0 0 8px;
	font-family: "Georgia", serif;
`;

export const MainIntro = styled.p`
	font-size: 15px;
	color: ${TEXT_DARK};
	line-height: 1.8;
	margin: 8px 0;
	font-style: italic;
`;

export const SubIntro = styled.p`
	font-size: 13px;
	color: #5a3040;
	line-height: 1.7;
	margin: 4px 0;
`;

export const CoupleImages = styled.div<{ colormatrix: TemplateColorObject }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 32px;
	margin-top: 16px;
	& > div {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
	}
	.partner_img {
		width: 300px;
		max-height: 400px;
		border-radius: 16px;
		background: #fff;
		border: 3px solid ${GOLD};
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
	}
`;

export const CoupleImg = styled.div<{ $color: string }>`
	width: 150px;
	height: 150px;
	border-radius: 16px;
	background: ${p => `linear-gradient(135deg, ${p.$color}, ${DARK_BURGUNDY})`};
	border: 3px solid ${GOLD};
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
`;

export const CoupleLabel = styled.p`
	font-size: 18px;
	color: ${BURGUNDY};
	letter-spacing: 1px;
	font-style: italic;
`;

export const QuranSection = styled.section<{ colormatrix: TemplateColorObject }>`
	background: ${props => props.colormatrix.background};
	padding: 40px 28px;
	text-align: center;
	position: relative;
	&::before,
	&::after {
		content: "✦";
		position: absolute;
		color: ${GOLD};
		opacity: 0.3;
		font-size: 60px;
	}
	&::before {
		top: 10px;
		left: 10px;
	}
	&::after {
		bottom: 10px;
		right: 10px;
	}
`;

export const Bismillah = styled.p`
	font-size: 22px;
	color: ${GOLD};
	direction: rtl;
	margin: 0 0 16px;
	letter-spacing: 1px;
`;

export const Verse = styled.p`
	font-size: 16px;
	color: ${LIGHT_GOLD};
	direction: rtl;
	line-height: 2;
	margin: 0 0 16px;
	font-style: italic;
`;

export const Ending = styled.p`
	font-size: 16px;
	color: ${GOLD};
	direction: rtl;
	font-weight: 600;
`;

export const LoveStorySection = styled.section<{ colormatrix: TemplateColorObject }>`
	background: #faf3e8;
	padding: 40px 28px;
	display: flex;
	flex-direction: column;
	align-items: center;

	.story_image {
		max-width: 350px;

		border-radius: 12px;
		background: #fff;
		border: 3px solid ${GOLD};
		margin: 20px 0;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
		position: relative;
		&::after {
			content: "❤";
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 48px;
			color: rgba(201, 168, 76, 0.4);
		}
	}
`;

export const SectionTitle = styled.h2`
	font-size: 26px;
	color: ${BURGUNDY};
	letter-spacing: 2px;
	font-weight: 400;
	margin: 0;
`;

export const StoryImage = styled.div<{ $color: string }>`
	width: 100%;
	height: 200px;
	border-radius: 12px;
	background: ${p => `linear-gradient(135deg, ${p.$color}, ${DARK_BURGUNDY})`};
	border: 3px solid ${GOLD};
	margin: 20px 0;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
	position: relative;
	&::after {
		content: "❤";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 48px;
		color: rgba(201, 168, 76, 0.4);
	}
`;

export const StoryList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const StoryItem = styled.div`
	border-left: 4px solid ${GOLD};
	padding: 12px 16px;
	background: white;
	border-radius: 0 8px 8px 0;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const StoryItemTitle = styled.h3`
	font-size: 16px;
	color: ${BURGUNDY};
	margin: 0 0 8px;
	letter-spacing: 1px;
`;

export const StoryItemContent = styled.p`
	font-size: 13px;
	color: #5a3040;
	line-height: 1.7;
	margin: 0;
	font-style: italic;
`;

export const GallerySection = styled.section`
	background: ${CREAM};
	padding: 40px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const GalleryGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 8px;
	margin-top: 20px;
`;

export const GalleryImg = styled.div<{ $color: string; $tall?: boolean }>`
	border-radius: 8px;
	background: ${p => `linear-gradient(135deg, ${p.$color}, ${DARK_BURGUNDY})`};
	border: 2px solid ${GOLD};
	height: ${p => (p.$tall ? "160px" : "110px")};
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	${p =>
		p.$tall &&
		css`
			grid-row: span 1;
		`}
`;

export const CommentsSection = styled.section<{ colormatrix: TemplateColorObject }>`
	background: ${props => props.colormatrix.background};
	padding: 40px 28px;
	display: flex;
	flex-direction: column;
	align-items: center;
	& ${SectionTitle} {
		color: ${LIGHT_GOLD};
	}
`;

export const CommentTitle = styled.h3`
	font-size: 18px;
	color: ${GOLD};
	font-weight: 400;
	letter-spacing: 1px;
	margin: 8px 0;
	text-align: center;
`;

export const CommentDesc = styled.p`
	font-size: 13px;
	color: ${LIGHT_GOLD};
	font-style: italic;
	margin: 0 0 20px;
	line-height: 1.7;
	text-align: center;
`;

export const CommentForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const CommentInput = styled.input`
	background: rgba(255, 255, 255, 0.1);
	border: 1px solid ${GOLD};
	border-radius: 8px;
	padding: 12px 16px;
	color: ${LIGHT_GOLD};
	font-size: 14px;
	outline: none;
	&::placeholder {
		color: rgba(232, 213, 163, 0.5);
	}
`;

export const CommentTextarea = styled.textarea`
	background: rgba(255, 255, 255, 0.1);
	border: 1px solid ${GOLD};
	border-radius: 8px;
	padding: 12px 16px;
	color: ${LIGHT_GOLD};
	font-size: 14px;
	outline: none;
	resize: none;
	font-family: Georgia, serif;
	&::placeholder {
		color: rgba(232, 213, 163, 0.5);
	}
`;

export const CommentBtn = styled.button`
	background: linear-gradient(135deg, ${GOLD}, #a07830);
	color: ${DARK_BURGUNDY};
	border: none;
	padding: 12px;
	border-radius: 30px;
	font-size: 14px;
	font-weight: 700;
	letter-spacing: 1px;
	text-transform: uppercase;
	cursor: pointer;
	transition: transform 0.2s;
	&:hover {
		transform: scale(1.03);
	}
`;

export const LocationSection = styled.section<{ colormatrix: TemplateColorObject }>`
	background: #faf3e8;
	padding: 40px 28px;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;

	button {
		background: ${props => props.colormatrix.button.background};
		color: ${props => props.colormatrix.button.text};
		border: 2px solid ${GOLD};
		padding: 12px 32px;
		font-size: 14px;
		letter-spacing: 2px;
		text-transform: uppercase;
		font-weight: 600;
		border-radius: 30px;
		cursor: pointer;
		transition: transform 0.2s;
		&:hover {
			transform: scale(1.05);
		}
	}
`;

export const LocationName = styled.p`
	font-size: 16px;
	color: ${BURGUNDY};
	font-style: italic;
	margin: 4px 0;
	letter-spacing: 1px;
`;

export const MapPlaceholder = styled.div`
	width: 100%;
	height: 200px;
	background: linear-gradient(135deg, #e8d5a3, #c9b47a);
	border-radius: 12px;
	border: 3px solid ${GOLD};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 20px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	span {
		font-size: 40px;
	}
	p {
		color: ${DARK_BURGUNDY};
		font-size: 14px;
		margin: 8px 0 0;
		font-style: italic;
	}
`;

export const LocationBtn = styled.button<{ colormatrix: TemplateColorObject }>`
	background: ${props => props.colormatrix.button.background};
	color: ${props => props.colormatrix.button.text};
	border: 2px solid ${GOLD};
	padding: 12px 32px;
	font-size: 14px;
	letter-spacing: 2px;
	text-transform: uppercase;
	font-weight: 600;
	border-radius: 30px;
	cursor: pointer;
	transition: transform 0.2s;
	&:hover {
		transform: scale(1.05);
	}
`;

export const Footer = styled.footer<{ colormatrix: TemplateColorObject }>`
	background: ${props => props.colormatrix.footer};
	padding: 28px 24px;
	text-align: center;
	border-top: 3px solid ${GOLD};
`;

export const Credit = styled.p`
	color: #fff;
	font-size: 13px;
	margin: 0 0 8px;
	letter-spacing: 1px;
`;

export const InstagramLink = styled.a`
	color: ${GOLD};
	font-size: 13px;
	text-decoration: none;
	letter-spacing: 1px;
	&:hover {
		text-decoration: underline;
	}
`;
